import { render, staticRenderFns } from "./TopEntityComponentLabel.vue?vue&type=template&id=1576b9bc&"
import script from "./TopEntityComponentLabel.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports